import React from "react";
import Link from "next/link";
import { docsColors } from "@/lib/docs-theme";

interface NavItem {
  href: string;
  text: string;
}

interface DocNavFooterProps {
  prev?: NavItem;
  next?: NavItem;
  className?: string;
}

export default function DocNavFooter({ prev, next, className = "" }: DocNavFooterProps) {
  if (!prev && !next) return null;

  return (
    <div
      className={`flex justify-between items-center pt-8 border-t ${docsColors.border.default} ${className}`}
    >
      {prev ? (
        <Link href={prev.href} className={docsColors.link.muted}>
          ← {prev.text}
        </Link>
      ) : (
        <span />
      )}
      {next && (
        <Link href={next.href} className={docsColors.link.primary}>
          {next.text} →
        </Link>
      )}
    </div>
  );
}
